import api from '@/services/Api';

class RentalPdfService {
  async getRentalContractPdf() {
    const response = await api.get(
      '/rental/distrib/rental-file-contract-pdf',
      {
        responseType: 'blob'
      })
    return response.data
  }
}

export default new RentalPdfService()
